export default __webpack_public_path__ + "static/media/content.92785b4f.png";